import { Routes } from '@angular/router';
import { personaMatch } from '@core/guards/workspace-match.guard';
import { dailyChallengesFeatureMatch } from '@core/guards/daily-challenges-feature.guard';

/**
 * Learner workspace routes (education or business learner persona).
 */
export const LEARNER_WORKSPACE_ROUTES: Routes = [
  // ── Home ───────────────────────────────────────────────────────────────────
  {
    path: '',
    pathMatch: 'full',
    canMatch: [personaMatch('learner')],
    loadComponent: () =>
      import(
        '../../pages/assessments/campaigns/assigned-assessments.page'
      ).then((m) => m.AssignedAssessmentsPage),
  },

  // ── Practice & progress ────────────────────────────────────────────────────
  {
    path: 'due',
    loadComponent: () =>
      import(
        '../../pages/assessments/campaigns/assigned-assessments.page'
      ).then((m) => m.AssignedAssessmentsPage),
  },
  {
    path: 'catalog',
    data: { ownerScope: 'workspace' },
    loadComponent: () =>
      import(
        '../../pages/assessments/marketplace/catalog/assessment-marketplace-catalog.page'
      ).then((m) => m.AssessmentMarketplaceCatalogPage),
  },
  {
    path: 'progress',
    loadComponent: () =>
      import(
        '../../pages/assessments/campaigns/assigned-assessments.page'
      ).then((m) => m.AssignedAssessmentsPage),
  },
  {
    path: 'achievements',
    loadComponent: () =>
      import(
        '../../pages/assessments/campaigns/assigned-assessments.page'
      ).then((m) => m.AssignedAssessmentsPage),
  },
  {
    path: 'self-test',
    loadComponent: () =>
      import('../../pages/workspaces/learner/self-test/self-test.page').then(
        (m) => m.SelfTestPage,
      ),
  },
  {
    path: 'daily-quizzes',
    canMatch: [dailyChallengesFeatureMatch],
    loadComponent: () =>
      import('../../pages/workspaces/learner/daily-quizzes/daily-quizzes.page').then(
        (m) => m.DailyQuizzesPage,
      ),
  },
  {
    path: 'daily-quizzes/:assessmentGuid/attempts/:attemptGuid',
    canMatch: [dailyChallengesFeatureMatch],
    data: { ownerScope: 'platform', minimalShell: true },
    loadComponent: () =>
      import('../../pages/assessments/attempt/assessment-attempt.page').then(
        (m) => m.AssessmentAttemptPage,
      ),
  },
  {
    path: 'result',
    loadComponent: () =>
      import(
        '../../pages/assessments/campaigns/assigned-assessments.page'
      ).then((m) => m.AssignedAssessmentsPage),
  },
  // Keep legacy completion links safe without loading the Quiz result client.
  {
    path: 'calendar/results/:quizGuid',
    loadComponent: () =>
      import(
        '../../pages/assessments/campaigns/assigned-assessments.page'
      ).then((m) => m.AssignedAssessmentsPage),
  },
];
